// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1bLXs","content":"styles_content__2BPKi","checkbox":"styles_checkbox__CApH1","checkboxLabel":"styles_checkboxLabel__3xdsg"};